module.exports = __webpack_public_path__ + "static/media/wisedb3.71c42b06.png";